
import axios from "axios";
import { store } from '../store';
import {router} from "../helpers";
import {i18n} from "../i18n";

export const tagService = {
    find,
    findUnactivated,
    findAnonymous,
    activate,
    notify
};

function find(code) {

    let apiClient = axios.create({
        baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
        headers: {'Accept-Language': i18n.locale},
        withCredentials: true,
    });

    return apiClient
        .get('/api/tags/' + code)
        .then(response => {

            // registration successful if there's a jwt token in the response
            if (response.status === 200 && response.data) {
                return response.data;
            }
            else {
                return Promise.reject('not found');
            }
        })
        .catch(function (error) {
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
                if (error.response.status === 422) {

                    // store server side validation errors
                    return store.dispatch('validationErrors', error.response.data.errors, { root: true }).then(response => {
                        return Promise.reject('check form for errors');
                    });

                }
                else {
                    return Promise.reject(error);
                }
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request);
            } else if (error.message) {
                // Something happened in setting up the request that triggered an Error
                console.log(error.message);
            } else {
                // The login was rejected due to incorrect role
                return Promise.reject(error);
            }
        });
}

function findAnonymous(code) {

    let apiClient = axios.create({
        baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
        headers: {'Accept-Language': i18n.locale},
    });

    return apiClient
        .get('/api/tags/' + code + '/anonymous')
        .then(response => {

            // registration successful if there's a jwt token in the response
            if (response.status === 200 && response.data) {
                return response.data;
            }
            else {
                return Promise.reject('not found');
            }
        })
        .catch(function (error) {
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
                if (error.response.status === 403) {
                    return store.dispatch('alert/error', error.response.data.error, {root: true}).then(response => {

                        return store.dispatch('validationErrors', error.response.data.error, { root: true }).then(response => {
                            return Promise.reject('this tag is not public');
                        });
                    });
                }
                if (error.response.status === 404) {
                    return store.dispatch('alert/error', 'this tag cannot be found', {root: true}).then(response => {
                        return store.dispatch('validationErrors', error.response.data.errors, { root: true }).then(response => {
                            return Promise.reject('this tag cannot be found');
                        });
                    });
                }
                if (error.response.status === 422) {

                    // store server side validation errors
                    return store.dispatch('validationErrors', error.response.data.errors, { root: true }).then(response => {
                        return Promise.reject('check form for errors');
                    });

                }
                else {
                    return Promise.reject(error);
                }
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request);
            } else if (error.message) {
                // Something happened in setting up the request that triggered an Error
                console.log(error.message);
            } else {
                // The login was rejected due to incorrect role
                return Promise.reject(error);
            }
        });
}

function notify(code, item, organisation, note) {

    let apiClient = axios.create({
        baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
        headers: {'Accept-Language': i18n.locale},
        withCredentials: true,
    });

    return apiClient
        .post('/api/tags/notify', {
            'qrCode' : code,
            'item' : item,
            'organisation' : organisation,
            'note' : note
        })
        .then(response => {

            // registration successful if there's a jwt token in the response
            if (response.status === 200 && response.data) {
                return store.dispatch('account/updateSMSCount', response.data.sms_count, { root: true }).then(response => {
                    return response;
                });
            }
            else {
                return Promise.reject('not found');
            }
        })
        .catch(function (error) {
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
                return Promise.reject(error);
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request);
            } else if (error.message) {
                // Something happened in setting up the request that triggered an Error
                console.log(error.message);
            } else {
                // The login was rejected due to incorrect role
                return Promise.reject(error);
            }
        });
}

function findUnactivated(code) {
    let apiClient = axios.create({
        baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
        headers: {'Accept-Language': i18n.locale},
        withCredentials: true,
    });

    return apiClient
        .get('/api/tags/unactivated/' + code)
        .then(response => {

            // registration successful if there's a jwt token in the response
            if (response.status === 200 && response.data) {
                return response.data;
            }
            else {
                return Promise.reject('not found');
            }
        })
        .catch(function (error) {
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
                if (error.response.status === 422) {

                    // store server side validation errors
                    return store.dispatch('validationErrors', error.response.data.errors, { root: true }).then(response => {
                        return Promise.reject('check form for errors');
                    });

                }
                if (error.response.status === 401) {

                    return Promise.reject(error);

                }
                else {
                    return Promise.reject(error);
                }
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request);
            } else if (error.message) {
                // Something happened in setting up the request that triggered an Error
                console.log(error.message);
            } else {
                // The login was rejected due to incorrect role
                return Promise.reject(error);
            }
        });
}

function activate(code, myself, dependant, isPublic) {
    let apiClient = axios.create({
        baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
        headers: {'Accept-Language': i18n.locale},
        withCredentials: true,
    });

    return apiClient
        .post('/api/tags/activate', {
            qr_code: code,
            myself: myself,
            dependant: dependant,
            is_public: isPublic
        })
        .then(response => {

            // registration successful if there's a jwt token in the response
            if (response.status === 200 && response.data) {
                return response.data;
            }
            else {
                return Promise.reject('not found');
            }
        })
        .catch(function (error) {
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
                if (error.response.status === 403) {
                    return store.dispatch('alert/error', error.response.data.error, { root: true }).then(response => {
                        return Promise.reject(error);
                    });
                }
                else {
                    return store.dispatch('alert/error', 'Tag not activated', { root: true }).then(response => {
                        return Promise.reject(error);
                    });
                }
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request);
            } else if (error.message) {
                // Something happened in setting up the request that triggered an Error
                console.log(error.message);
            } else {
                // The login was rejected due to incorrect role
                return Promise.reject(error);
            }
        });
}

